import React from 'react'
import FontIcon from 'material-ui/FontIcon'

import { noResultsStyles } from '../styles/theme'

const NoResults = ({
  centered = true,
  title = 'Nessun Risultato',
  icon = 'mood_bad',
  children,
}) => (
  <div className={centered ? 'text-center' : ''}>
    <FontIcon className="material-icons" style={noResultsStyles.iconStyle}>
      {icon}
    </FontIcon>
    <h2 style={noResultsStyles.titleStyle}>{title}</h2>
    {children && <div>{children}</div>}
  </div>
)

export default NoResults



// WEBPACK FOOTER //
// ./src/common/NoResults.js